export default class ClubPermissionIntraKey {
    static fromData(data) {
        if (!data) {
            return;
        }

        let clubPermissionIntraKey = new ClubPermissionIntraKey();
        clubPermissionIntraKey.id = data.id;
        clubPermissionIntraKey.externalId = data.externalId;
        clubPermissionIntraKey.name = data.name;

        Object.seal(clubPermissionIntraKey);
        return clubPermissionIntraKey;
    }
}
